/*
  Tohfa by Sonia — product page.

  Three small behaviours, each a no-op if its markup is absent:
    1. gallery — thumbs swap the main image
    2. gift note — live character counter
    3. pincode — 6-digit format check, then reveal the shop-wide delivery line

  Everything that matters works without JavaScript: both Add to bag and Buy now are
  plain form submits, the gift note posts as a line item property, and the main
  image renders server-side.
*/
(function () {
  /* ---------- gallery ---------- */
  var main = document.querySelector('[data-pdp-main]');
  var thumbs = document.querySelectorAll('[data-pdp-thumb]');

  if (main && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var img = main.querySelector('img');
        if (!img) return;

        img.removeAttribute('srcset');
        img.src = thumb.dataset.full;
        img.alt = thumb.dataset.alt || '';

        thumbs.forEach(function (other) {
          other.classList.toggle('is-active', other === thumb);
        });
      });
    });
  }

  /* ---------- gift note counter ---------- */
  var note = document.querySelector('[data-note-input]');
  var counter = document.querySelector('[data-note-count]');

  if (note && counter) {
    var max = note.getAttribute('maxlength') || '300';

    var updateCount = function () {
      counter.textContent = note.value.length + ' / ' + max;
    };

    note.addEventListener('input', updateCount);
    updateCount();
  }

  /* ---------- pincode ---------- */
  var wrap = document.querySelector('[data-pin-check]');
  if (!wrap) return;

  var input = wrap.querySelector('[data-pin-input]');
  var button = wrap.querySelector('[data-pin-submit]');
  var result = wrap.querySelector('[data-pin-result]');
  if (!input || !button || !result) return;

  /*
    Serviceability hook.

    Today this only confirms the pincode is well-formed and returns the shop-wide
    window that Liquid already rendered — it deliberately claims nothing
    pincode-specific, because no courier data is connected (brief §7.2).

    To wire a real courier (Delhivery / iThink), make this async, call their
    serviceability endpoint, and resolve { serviceable, message }. Nothing else in
    this file needs to change.
  */
  function checkServiceability(pincode) {
    if (!/^\d{6}$/.test(pincode)) {
      return { serviceable: false, message: wrap.dataset.error };
    }
    return { serviceable: true, message: wrap.dataset.success };
  }

  function check() {
    var outcome = checkServiceability(input.value.trim());
    result.textContent = outcome.message;
    result.classList.toggle('is-error', !outcome.serviceable);
  }

  button.addEventListener('click', check);

  input.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    check();
  });
})();
